<template>
  <BreadCrumb class="hidden sm:block" />
  <StoriesCategoryPage :entry="entry" :social-media-accounts="socialMediaAccounts" />
</template>

<script>
import gql from 'graphql-tag';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import StoriesCategoryPage, { StoriesCategoryPageFragment } from '@/components/stories/StoriesCategoryPage';
import { stripLocale } from '@/utils/i18n';
import { SocialMediaAccountsFragment } from '@/components/layout/footer/SocialMediaAccounts';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const StoriesCategoryQuery = gql`
  query StoriesCategoryQuery($site: String!, $uri: String!) {
    entry(section: "stories", site: [$site], uri: [$uri]) {
      ...EntryPageFragment
      ...StoriesCategoryPageFragment
    }

    socialSet: globalSet(site: [$site], handle: "socialMediaAccounts") {
      ...SocialMediaAccountsFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${StoriesCategoryPageFragment}
  ${SeomaticFragment}
  ${SocialMediaAccountsFragment}
`;

export default defineNuxtComponent({
  name: 'StoriesCategoryController',
  components: { StoriesCategoryPage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    const {
      entry,
      seomatic,
      socialSet: { socialMediaAccounts },
    } = await $craftRequest(StoriesCategoryQuery, variables);

    return { entry, seomatic, socialMediaAccounts };
  },

  data() {
    return { socialMediaAccounts: [] };
  },

  created() {
    useEntryPage(this.entry, this.seomatic, { content_category: 'stories' });
  },
});
</script>
